/**
 * Space date availability utilities.
 *
 * Pure functions with zero external dependencies.
 *
 * Date strings use the project's YYYYMMDD format with zero-based months
 * (matching Day.ref / booking document IDs).
 *
 * DROP INTO: src/utils/spaceAvailability.js
 */

/**
 * Convert a Date to a YYYYMMDD ref string (zero-based month).
 *
 * Example: new Date(2026, 2, 22) → "20260222"
 *          (March is month 2 in JS, kept as-is)
 */
export function dateToRef(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth()).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
}

/**
 * Convert a YYYYMMDD ref string (zero-based month) back to a Date.
 *
 * Example: "20260222" → new Date(2026, 2, 22)  (March 22)
 */
export function refToDate(ref) {
  const year = parseInt(ref.slice(0, 4), 10);
  const month = parseInt(ref.slice(4, 6), 10);
  const day = parseInt(ref.slice(6, 8), 10);
  return new Date(year, month, day);
}

/**
 * Check whether a space should be visible on a given date.
 *
 * Rules:
 *  - If bookableFrom is set and dateRef < bookableFrom → hidden (too early)
 *  - If bookableUntil is set and dateRef > bookableUntil → hidden (too late)
 *  - Otherwise → visible
 *  - Empty/undefined fields mean no restriction on that end
 */
export function isSpaceAvailableOnDate(spaceData, dateRef) {
  if (spaceData.bookableFrom && dateRef < spaceData.bookableFrom) return false;
  if (spaceData.bookableUntil && dateRef > spaceData.bookableUntil) return false;
  return true;
}
